export default __webpack_public_path__ + "static/media/logical-or.9d16cf24.svg";